import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyledLevelDescription, StyledSlider } from './ValueAddModernizationSlider.styled'
import { useSelector } from 'react-redux'
import { selectAddressFormData, setFormField } from 'slices/addressFormSlice'
import { useAppDispatch } from 'store/hooks'
import { ModernizationValueType } from 'types/ApiResponse'

const MODERNIZATION_VALUE_MAP = {
  10: ModernizationValueType.NONE,
  20: ModernizationValueType.LIGHT,
  30: ModernizationValueType.MEDIUM,
  40: ModernizationValueType.MOST,
  50: ModernizationValueType.FULL,
}

const getModernizationValue = (value: number) => {
  return MODERNIZATION_VALUE_MAP[value] || ModernizationValueType.MEDIUM
}

const getModernizationValueNumber = (modernizationValue?: ModernizationValueType) => {
  return (
    Object.keys(MODERNIZATION_VALUE_MAP).filter(
      (key) => MODERNIZATION_VALUE_MAP[key] === modernizationValue
    )[0] || 40
  )
}

const ValueAddModernizationSlider = (props: any) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const addressFormData = useSelector(selectAddressFormData)
  const marks = [
    {
      value: 10,
      label: <p>{t(`modernizationValue.${ModernizationValueType.NONE.toLowerCase()}`)}</p>,
    },
    {
      value: 20,
      label: <p>{t(`modernizationValue.${ModernizationValueType.LIGHT.toLowerCase()}`)}</p>,
    },
    {
      value: 30,
      label: <p>{t(`modernizationValue.${ModernizationValueType.MEDIUM.toLowerCase()}`)}</p>,
    },
    {
      value: 40,
      label: <p>{t(`modernizationValue.${ModernizationValueType.MOST.toLowerCase()}`)}</p>,
    },
    {
      value: 50,
      label: <p>{t(`modernizationValue.${ModernizationValueType.FULL.toLowerCase()}`)}</p>,
    },
  ]

  const handleChange = (_: Event, newValue: number) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.modernizationValue',
        value: getModernizationValue(newValue),
      })
    )
  }

  if (addressFormData.addressData?.propertyDetails?.modernizationValue === undefined) {
    dispatch(
      setFormField({
        key: 'propertyDetails.modernizationValue',
        value: ModernizationValueType.MEDIUM,
      })
    )
  }

  return (
    <div style={{ marginTop: 100 }}>
      <StyledSlider
        marks={marks}
        min={5}
        max={55}
        step={null}
        track={false}
        defaultValue={getModernizationValueNumber(
          addressFormData.addressData?.propertyDetails?.modernizationValue
        )}
        onChange={handleChange}
      />
      {addressFormData.addressData?.propertyDetails?.modernizationValue !== undefined && (
        <StyledLevelDescription>
          <b>
            {t(
              `modernizationValue.${addressFormData.addressData?.propertyDetails?.modernizationValue.toLowerCase()}`
            )}
            :
          </b>{' '}
          {t(
            `modernizationValue.${addressFormData.addressData?.propertyDetails?.modernizationValue.toLowerCase()}.description`
          )}
        </StyledLevelDescription>
      )}
    </div>
  )
}

export default ValueAddModernizationSlider
